var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#long-arrow--mp6I6';
                    var viewUrl = 'sprites.svg#view-long-arrow--mp6I6';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 54 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };